// extracted by mini-css-extract-plugin
export default {"cls1":"O5Y5oaFhH0_MSWrKoAQs","cls2":"yebcDG5SKdEVF89HRvTA O5Y5oaFhH0_MSWrKoAQs"};